import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import translate from '../../../../components/TranslateHOC';

export const SkipToLink = ({ strings }) => {
  return (
    <SkipToLinkButton href="#main">
      {strings.skipToMainContent}
    </SkipToLinkButton>
  );
};

const SkipToLinkButton = styled.a`
  ${(props) => props.theme.fontBold};
  position: absolute;
  top: 10px;
  left: 13px;
  padding: 14px 16px;
  width: max-content;
  background: ${(props) => props.theme.color.primary75};
  border-radius: 8px;
  color: ${(props) => props.theme.color.blackFull} !important;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-decoration: underline;
  text-underline-offset: 3px;
  transform: translateY(-150%);
  transition: transform 0.3s;
  z-index: 1;
  @media screen and (min-width: 768px) {
    top: 24px;
    left: 20px;
  }
  @media screen and (min-width: 1024px) {
    top: 21px;
    left: initial;
    font-size: 18px;
    line-height: 27px;
    padding: 14px 20px;
  }
  &:focus {
    transform: translateY(0%);
    outline: 2px solid
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.statusLightFocus
          : props.theme.color.statusDarkFocus};
    outline-offset: 2px;
  }
`;

export default translate(connect(null)(SkipToLink));
